export default function motor() {
    if(document.querySelector(".booking")) {
        let reservChildrensSelect = document.querySelector(".childrens");
        let reservFieldChildrens = document.querySelector(".field-childrens");

        reservChildrensSelect.addEventListener("change", () => {
            let quantityChildrens = Number(reservChildrensSelect.value);
            let reservSelectChildrens = reservFieldChildrens.querySelectorAll("#age-children");
            let cont = 0;

            reservSelectChildrens.forEach(select => {
                select.remove();
            });

            function addFieldAgeChildren() {
                let fieldAgeChildren = document.createElement("div");

                fieldAgeChildren.innerHTML = `
                    <select name="age-children[]" id="age-children">
                        <option selected disabled>Idade da criança ${cont + 1}</option>
                        <option value="0">0 anos</option>
                        <option value="1">1 ano</option>
                        <option value="2">2 anos</option>
                        <option value="3">3 anos</option>
                        <option value="4">4 anos</option>
                        <option value="5">5 anos</option>
                        <option value="6">6 anos</option>
                        <option value="7">7 anos</option>
                        <option value="8">8 anos</option>
                        <option value="9">9 anos</option>
                        <option value="10">10 anos</option>
                        <option value="11">11 anos</option>
                        <option value="12">12 anos</option>
                        <option value="12">13 anos</option>
                        <option value="12">14 anos</option>
                        <option value="12">15 anos</option>
                    </select>
                `;

                reservFieldChildrens.appendChild(fieldAgeChildren);
            }

            while(cont < quantityChildrens) {
                addFieldAgeChildren();
                cont++;
            }
        });
    }
}
